import { render } from "./sitemapCom.vue?vue&type=template&id=21bf504f"
import script from "./sitemapCom.vue?vue&type=script&lang=js"
export * from "./sitemapCom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__